import { c as _c } from "react/compiler-runtime";
import { addHours, startOfHour, subDays } from 'date-fns';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { useTheme } from 'styled-components';
import useSWR from 'swr';
import { SeekPagination } from '../../../../../../../../typings/API.interface';
import { APISource } from '../../../../../../../../typings/Source.interface';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { formatNumberShorthand } from '../../../../../utils';
import { useCopyToClipboard } from '../../../../../utils/copy';
import formatMetricsQuery from '../../../../../utils/formatMetricsQuery';
import Button from '../../../../common/base/Button';
import Icon, { IconName } from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Dropdown from '../../../../common/Dropdown';
import DropdownMenu from '../../../../common/DropdownMenu';
import EmptyState, { EmptyResults, StyledEmptyStateWrapper } from '../../../../common/EmptyState';
import { Div } from '../../../../common/helpers/StyledUtils';
import { buildPreviewBuckets, GROUP_METRICS_BY_2H, GROUP_METRICS_BY_4H, PreviewBucket, PreviewMetricEntry } from '../../../../common/Histogram/PreviewHistogram';
import Table from '../../../../common/Table/Table';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import useMetricsQuery from '../../../../hooks/useMetricsQuery';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { DashboardContext } from '../../DashboardContext';
import useOnDisableToggle from '../List/hooks/useOnDisableToggle';
import SourceMetricsPreview from '../List/SourceMetricsPreview';
import SourcePreview from '../List/SourcePreview';
import { StatusBadge } from '../List/StatusBadge';
import { SourcesListQueryParams } from './SourcesView';
const now = addHours(startOfHour(new Date()), 1);
const SourceName = t0 => {
  const $ = _c(14);
  const {
    name,
    icon,
    authenticated,
    source,
    mutate
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      l: -2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      min: 408
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== authenticated || $[4] !== icon || $[5] !== name) {
    t4 = (opened, toggle) => <Button ghost={true} active={opened} icon={icon} style={{
      maxWidth: "100%"
    }} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}><Text as="span" mono={true} ellipsis={true}>{name}</Text>{authenticated && <Icon icon="verification" muted={true} right={true} pointer={true} />}</Button>;
    $[3] = authenticated;
    $[4] = icon;
    $[5] = name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["name", "type"];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== mutate || $[9] !== source) {
    t6 = <SourcePreview source={source} fields={t5} mutate={mutate} />;
    $[8] = mutate;
    $[9] = source;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <Div flex={true} m={t1} min_w={0}><Div onClick={_temp} style={t2}><Dropdown placement="bottom-start" parent_width={t3} portal={true} renderToggle={t4}>{t6}</Dropdown></Div></Div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
const SourceStatus = t0 => {
  const $ = _c(9);
  const {
    source,
    mutate
  } = t0;
  const onDisable = useOnDisableToggle("sources", mutate);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [4, 8];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== source) {
    t2 = (opened, toggle) => <Button ghost={true} active={opened} m={-1} p={1} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}><StatusBadge resource={source} /></Button>;
    $[1] = source;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onDisable || $[4] !== source) {
    t3 = [source.disabled_at ? {
      icon: "enable",
      label: "Enable source",
      description: "Accepts all incoming requests to your source URL.",
      onClick: () => onDisable(source, false)
    } : {
      icon: "disable",
      label: "Disable source",
      description: "Rejects all incoming requests to your source URL.",
      onClick: () => onDisable(source, true)
    }];
    $[3] = onDisable;
    $[4] = source;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Div flex={true}><Div onClick={_temp2}><DropdownMenu placement="bottom-end" ghost={true} offset={t1} renderToggle={t2} icon="horizontal_more" options={t3} /></Div></Div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
const SourceUrl = t0 => {
  const $ = _c(16);
  const {
    url
  } = t0;
  const copyToClipboard = useCopyToClipboard();
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      maxWidth: "100%"
    };
    t2 = () => setIsHovered(true);
    t3 = () => setIsHovered(false);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== copyToClipboard || $[4] !== url) {
    t4 = e => {
      copyToClipboard(url);
      e.stopPropagation();
    };
    $[3] = copyToClipboard;
    $[4] = url;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      flexGrow: 1
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isHovered) {
    t6 = isHovered && <Icon icon="copy" muted={true} pointer={true} right={true} />;
    $[7] = isHovered;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6 || $[10] !== url) {
    t7 = <Text size="s" mono={true} ellipsis={true} style={t5}>{url}{t6}</Text>;
    $[9] = t6;
    $[10] = url;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7 || $[14] !== url) {
    t8 = <Div flex={true} min_w={0}><Button key={url} ghost={true} m={-1.75} style={t1} onMouseEnter={t2} onMouseLeave={t3} onClick={t4}>{t7}</Button></Div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = url;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
const SourceConnections = t0 => {
  const $ = _c(27);
  const {
    source
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const [is_open, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== source.id) {
    t1 = APIMethodKeys.webhooks.count({
      source_id: source.id
    });
    $[0] = source.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== source.id) {
    t2 = () => HookdeckAPI.webhooks.count({
      source_id: source.id
    });
    $[2] = HookdeckAPI.webhooks;
    $[3] = source.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: connections_count
  } = useSWR(t1, t2);
  let t3;
  if ($[5] !== is_open || $[6] !== source.id) {
    t3 = is_open && APIMethodKeys.webhooks.list({
      source_id: source.id
    });
    $[5] = is_open;
    $[6] = source.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== HookdeckAPI.webhooks || $[9] !== source.id) {
    t4 = () => HookdeckAPI.webhooks.list({
      source_id: source.id
    });
    $[8] = HookdeckAPI.webhooks;
    $[9] = source.id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: connections
  } = useSWR(t3, t4);
  const count = connections_count?.count || 0;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      l: -2
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = typeof connections === "undefined";
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      min: 300
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== count || $[14] !== history || $[15] !== source.id) {
    t8 = (opened, toggle) => <Button ghost={true} active={opened} onClick={e_0 => {
      if (count === 0) {
        history.push("/connections/new?source_id=" + source.id);
      }
      toggle(!opened);
      e_0.stopPropagation();
    }}><Text muted={count !== 0} neutral={count === 0}>{count === 0 ? "Add " : count}</Text>{count === 0 && <Icon neutral={true} icon="add_circle" pointer={true} m={{
        l: 1
      }} />}</Button>;
    $[13] = count;
    $[14] = history;
    $[15] = source.id;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== history || $[18] !== source.id) {
    t9 = () => <Div p={1}><Button w={100} ghost={true} icon="add_circle" onClick={() => {
        history.push("/connections/new?source_id=" + source.id);
      }}>New connection</Button></Div>;
    $[17] = history;
    $[18] = source.id;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== connections?.models) {
    t10 = connections?.models.map(_temp4) || [];
    $[20] = connections?.models;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
    t11 = <Div flex={true} m={t5}><Div onClick={_temp3}><DropdownMenu placement="bottom-end" ghost={true} portal={true} search={true} search_is_loading={t6} parent_width={t7} onToggle={setIsOpen} renderToggle={t8} getItemsFooter={t9} options={t10} /></Div></Div>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
const SourceRequests = t0 => {
  const $ = _c(13);
  const {
    source,
    timeseries_2h_sample,
    timeseries_4h_sample,
    count
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      gap: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 40
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = count || 0;
  let t4;
  if ($[2] !== t3) {
    t4 = formatNumberShorthand(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <Text w={t2} muted={true} number={true}>{t4}</Text>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== source || $[7] !== timeseries_2h_sample || $[8] !== timeseries_4h_sample) {
    t6 = <SourceMetricsPreview data_2h_sample={timeseries_2h_sample} data_4h_sample={timeseries_4h_sample} source={source} />;
    $[6] = source;
    $[7] = timeseries_2h_sample;
    $[8] = timeseries_4h_sample;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Div flex={t1} min_w={0}>{t5}{t6}</Div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
type Pagination = SeekPagination & {
  page_size: number;
};
const SourcesList = t0 => {
  const $ = _c(48);
  const {
    sources,
    total,
    loading,
    pagination,
    mutate,
    filtering
  } = t0;
  const [current_page, setCurrentPage] = useState(1);
  const {
    source_types
  } = useContext(DashboardContext);
  const history = useHistory();
  const {
    updateSearchQuery
  } = useSearchQuery();
  const theme = useTheme();
  let t1;
  if ($[0] !== sources) {
    const query_params = {
      filters: {
        date: {
          min: subDays(now, 1).toISOString(),
          max: now.toISOString()
        },
        source_id: sources?.map(_temp5)
      },
      granularity: "hour" as const,
      dimensions: ["source_id", "status"]
    };
    t1 = sources ? formatMetricsQuery("Requests", query_params) : null;
    $[0] = sources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const metrics_query = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      resetResultSetOnChange: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    raw_data
  } = useMetricsQuery(metrics_query, t2);
  let t3;
  let timeseries_2h_by_source_id;
  if ($[3] !== raw_data || $[4] !== sources) {
    const entries = raw_data?.map(_temp6) ?? null;
    const source_ids = sources.map(_temp7);
    timeseries_2h_by_source_id = entries && buildPreviewBuckets(source_ids, entries, GROUP_METRICS_BY_2H, now);
    t3 = entries && buildPreviewBuckets(source_ids, entries, GROUP_METRICS_BY_4H, now);
    $[3] = raw_data;
    $[4] = sources;
    $[5] = t3;
    $[6] = timeseries_2h_by_source_id;
  } else {
    t3 = $[5];
    timeseries_2h_by_source_id = $[6];
  }
  const timeseries_4h_by_source_id = t3;
  let t4;
  if ($[7] !== raw_data || $[8] !== sources) {
    let t5;
    if ($[10] !== raw_data) {
      t5 = (obj, t6) => {
        const {
          id: id_1
        } = t6;
        obj[id_1] = raw_data?.reduce((acc, entry) => {
          if (entry?.["Requests.source_id"] === id_1) {
            acc = acc + parseInt(entry?.["Requests.count"]);
          }
          return acc;
        }, 0);
        return obj;
      };
      $[10] = raw_data;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = sources.reduce(t5, {});
    $[7] = raw_data;
    $[8] = sources;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const count_by_source_id = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      min: 100
    }, {
      min: 340,
      max: 340
    }, {
      min: 100,
      max: 100
    }, {
      min: 160,
      max: 160
    }, {
      min: 100,
      max: 100
    }];
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const widths = t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["Source", "Source URL", "Status", "Requests (24h)", "Connections"];
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const headers = t6;
  let t7;
  if ($[14] !== count_by_source_id || $[15] !== loading || $[16] !== mutate || $[17] !== source_types || $[18] !== sources || $[19] !== timeseries_2h_by_source_id || $[20] !== timeseries_4h_by_source_id) {
    t7 = loading ? [] : sources.reduce((rows, source) => [...rows, {
      id: source.id,
      expendable: false,
      fields: [<SourceName key={source.id} name={source.name} icon={source_types?.[source.type]?.icon as IconName || "source"} authenticated={!!source.authenticated} source={source} mutate={mutate} />, <SourceUrl key={source.id} url={source.url} />, <SourceStatus key={source.id} source={source} mutate={mutate} />, <SourceRequests key={source.id} source={source} timeseries_2h_sample={timeseries_2h_by_source_id?.[source.id] || []} timeseries_4h_sample={timeseries_4h_by_source_id?.[source.id] || []} count={count_by_source_id?.[source.id] || 0} />, <SourceConnections key={source.id} source={source} />]
    }], []);
    $[14] = count_by_source_id;
    $[15] = loading;
    $[16] = mutate;
    $[17] = source_types;
    $[18] = sources;
    $[19] = timeseries_2h_by_source_id;
    $[20] = timeseries_4h_by_source_id;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const rows_0 = t7;
  let t8;
  if ($[22] !== history) {
    t8 = id_2 => {
      history.push(`/sources/${id_2}`);
    };
    $[22] = history;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const onRowSelected = t8;
  if (sources.length === 0 && !loading) {
    if (filtering) {
      let t9;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <StyledEmptyStateWrapper><EmptyResults label="No sources found" /></StyledEmptyStateWrapper>;
        $[24] = t9;
      } else {
        t9 = $[24];
      }
      return t9;
    }
    const t9 = `sources-${theme.mode}.png`;
    let t10;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = {
        label: "Add a source",
        icon: "add_circle",
        to: "/sources/new"
      };
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    let t11;
    if ($[26] !== t9) {
      t11 = <EmptyState title="Send HTTP requests to Hookdeck" description="Sources represent services that send HTTP requests to Hookdeck. Add a source to receive a URL that can be pasted into sender platforms, or used in code when making the HTTP request." asset={t9} asset_position="background" cta={t10} />;
      $[26] = t9;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    return t11;
  }
  const t9 = rows_0 as any;
  const t10 = pagination?.page_size || 50;
  let t11;
  if ($[28] !== current_page || $[29] !== t10) {
    t11 = {
      current_page,
      page_size: t10,
      entity_name: "sources"
    };
    $[28] = current_page;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== current_page || $[32] !== pagination || $[33] !== updateSearchQuery) {
    t12 = pagination?.next ? () => {
      updateSearchQuery({
        next: pagination.next,
        prev: undefined
      });
      setCurrentPage(current_page + 1);
    } : undefined;
    $[31] = current_page;
    $[32] = pagination;
    $[33] = updateSearchQuery;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== current_page || $[36] !== pagination || $[37] !== updateSearchQuery) {
    t13 = pagination?.prev ? () => {
      updateSearchQuery({
        prev: pagination.prev,
        next: undefined
      });
      setCurrentPage(current_page - 1);
    } : undefined;
    $[35] = current_page;
    $[36] = pagination;
    $[37] = updateSearchQuery;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== loading || $[40] !== onRowSelected || $[41] !== sources.length || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t9 || $[46] !== total) {
    t14 = <Div h={100}><Table fill={true} list={true} headers={headers} widths={widths} top_offset={106} rows={t9} loading={loading} loading_title="Sources loading" loading_message="It may take a few moments to populate your sources." onRowSelected={onRowSelected} pagination={t11} onNextPage={t12} onPreviousPage={t13} current_count={sources.length} total_count={total} /></Div>;
    $[39] = loading;
    $[40] = onRowSelected;
    $[41] = sources.length;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t9;
    $[46] = total;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  return t14;
};
export default SourcesList;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(connection) {
  return {
    label: connection.full_name,
    to: `/connections/${connection.id}`
  };
}
function _temp5(t0) {
  const {
    id
  } = t0;
  return id;
}
function _temp6(e) {
  return {
    time: new Date(e["Requests.createdAt"]).getTime(),
    count: parseInt(e["Requests.count"] || "0", 10),
    id: e["Requests.source_id"],
    dimension: e["Requests.status"]?.toLowerCase() || e["Requests.status"]
  };
}
function _temp7(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}